import { Networks, Position } from '@iotv/iotv-v3-types'
import { CoreApplicationObjectType } from '../types'

export enum GatewayState { //Temp same as Device State as BO incomplete
  UNKNOWN = 'UNKNOWN',
  COMMISSIONED = 'COMMISSIONED',
  DECOMMISSONED = 'DECOMMISSONED',
  SUSPENDED = 'SUSPENDED',
  CALIBRATED = 'CALIBRATED',
  TRANSITIN = 'TRANSITIN',
  TRANSITOUT = 'TRANSITOUT',
  WITHCUSTOMER = 'WITHCUSTOMER',
  WITHENGINEER = 'WITHENGINEER',
  INVENTORY = 'INVENTORY',
  ORDEREDCUSTOMER = 'ORDEREDCUSTOMER',
  ORDERED = 'ORDERED',
  RETIRED = 'RETIRED',
}

export interface IGateway extends CoreApplicationObjectType {
  eui?: string
  lastSeen?: number
  lastDeviceSeen?: string
  model?: string
  ports?: number
  channels?: number
  frequency?: number
  primaryGatewayUplinkCount?: number
  secondaryGatewayReceiveCount?: number
  state?: GatewayState
  location?: Position
  networkKey?: Networks
}
